'use strict';
module.exports = require('./TabView.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/tabview/index.js
// module id = 383
// module chunks = 1